export default __webpack_public_path__ + "static/Addam_Hardy_Resume_04-01-2022-18-52-17-679dda79cf4ce5efceb0c29edc556a0d.pdf";